import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/vant.js'
import 'amfe-flexible'   //rem转换包
import  './utils/dayjs'

import Vant,{Lazyload} from 'vant';
import 'vant/lib/index.css'
Vue.use(Vant);
Vue.use(Lazyload);
//网络请求
import {postReq} from "./utils/api";
import {getReq} from "./utils/api";
import {putReq} from "./utils/api";
import {deleteReq} from "./utils/api";
import {instance} from "./utils/api";

Vue.config.productionTip = false;

import i18n from './i18n'

Vue.prototype.postReq = postReq;
Vue.prototype.getReq  = getReq;
Vue.prototype.putReq  = putReq;
Vue.prototype.deleteReq  = deleteReq;
Vue.prototype.instance  = instance;
//前置路由守卫

router.beforeEach((to,from,next)=>{
  const tokenStr = window.localStorage.getItem("tokenStr");
  if (to.matched.some((r) => r.meta.isUserLogin)) {
    if (tokenStr) {
      next();
    } else {
     // Toast.fail("您尚未登录 请先登录");
      next({
        path: "/Login",
        param: { redirect: to.fullPath },
      });
    }
  } else {
    next();
  }
});
//后置路由守卫
// router.afterEach((to, from, next) => {
//
// });
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
